<div class="text-center" style="padding:3rem 0;">
	<img [src]="imgSrc" [alt]="altText" style="padding:1rem; max-width:100%">
	<br>
	<span class="h5" [innerHTML]="title"></span>
	<p>{{description}}</p>
	<div #content><ng-content></ng-content></div>
</div>
